import styled from "styled-components";
import { Button } from "antd";

export const AlertNotificationCardStyles = styled.div`
    display: inline-flex;
    max-width: 360px;
    padding: 16px;
    align-items: flex-start;
    gap: 16px;
    border-radius: 12px;
    background: ${({ theme }) => theme.colors.contentBgOpaque};
    box-shadow: 0px 4px 0px 0px rgba(0, 67, 101, 0.08);
    backdrop-filter: blur(8px);
`;

export const IconContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
`;

export const MessageContainer = styled.div`
    display: flex;
    width: 304px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
`;

export const Title = styled.h2`
    color: ${({ theme }) => theme.colors.headings};
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%;
`;

export const Message = styled.p`
    color: ${({ theme }) => theme.colors.paragraphs};
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%
`;

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
`;

export const DeleteButton = styled(Button)`
    && {
        background: transparent;
        color: ${({ theme }) => theme.colors.headings};
        border: 1px solid ${({ theme }) => theme.colors.headings};
        border-radius: 32px;
        padding: 4px 16px;
        height: auto;
        font-size: 12px;
        
        &:hover {
            background: transparent;
            color: ${({ theme }) => theme.colors.headings};
            border: 1px solid ${({ theme }) => theme.colors.headings};
            opacity: 0.8;
        }
    }
`;

export const HideButton = styled(Button)`
    && {
        background: ${({ theme }) => theme.colors.theme.brandColor2};
        color: ${({ theme }) => theme.colors.text.headings};
        border: none;
        border-radius: 32px;
        padding: 4px 16px;
        height: auto;
        font-size: 12px;
        

        &:hover {
            background: ${({ theme }) => theme.colors.theme.brandColor2};
            opacity: 0.8;
        }
    }
`;







